import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from 'axios';
import MenubarView from './MenubarView';
import { useEffect, useState } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { Toolbar } from 'primereact/toolbar';
import { useNavigate } from "react-router";

const EstimateView = (props) => {
    const [entries, setEntries] = useState(null)
    const [total,setTotal] = useState (0.00)

    const navigate  = useNavigate()
    if (localStorage.getItem('adminAccess') !== 'true')  
        navigate('/unauthorized')


    useEffect(() => {
        fetchEntryData()
    }, [])

    const fetchEntryData = () => {
        setEntries(null)
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        const url =   '/v1/estimateentries';
        axios.get(url,config)
        .then(response => {
            setEntries(response.data)
        })
    }

    const onRowEditComplete = (e) => { 
        entries.forEach(item => {
            if (item.id === e.newData.id) {
                item.amount=e.newData.amount
            }
        })
        let body = 'amount=' + e.newData.amount;
        let uri =   '/v1/updateestimateentry/' + e.newData.id
        const token = localStorage.getItem('bearerToken')
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        axios.post(uri,body,config)
            .catch(err => {
                console.error(err)
                throw err
        })
        calculateTotals(entries)
        //setTotal(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(t))
    };

  
    const amountEditor = (options) => {
        return <InputNumber value={options.value} onValueChange={(e) => options.editorCallback(e.value)} mode="currency" currency="USD" locale="en-US" />;
    };

    const amountBodyTemplate = (rowData) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rowData.amount);
    };

    const calculateTotals = (options) => {
        if (options.length === 0) 
            return
        else
            console.log(options)
        var t = 0.00
        options.forEach(item => {
            t += item.amount;

        })
        setTotal(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(t))
    }

    const rightToolbarTemplate = () => {
        
        if (total === 0.00) {console.log('got here')
            entries && calculateTotals(entries)
        };
        return (
            <React.Fragment>
                <div  style={{'text-align':'left'}}> Estimated profit or loss of <span style={{'color':'orange', fontWeight:'bold'}}>{total}</span></div>
            </React.Fragment>
        )
    }
    const mystyle = {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: '100px',
        width: '50%',
        height: '50%'
    }

        
    if (entries === null) {
        return (
            <img alt='loading' style={mystyle} src='./logo.gif'/>
        )
    } else {

    return (
        <>  
            <div>
            <MenubarView/>
            <Toolbar className="p-mb-2" end={rightToolbarTemplate}></Toolbar>
            </div>
            <div className="card p-fluid">
                
                <DataTable  value={entries} editMode="row" dataKey="id" 
                    onRowEditComplete={onRowEditComplete} tableStyle={{ minWidth: '50rem' }} 
                    emptyMessage="No records found" onValueChange={calculateTotals}>
                    
                    <Column selectionMode="multiple" headerStyle={{minWidth:'3rem'}}/>
                    <Column rowEditor headerStyle={{ width:'10%', minWidth:'7rem'}} bodyStyle={{ textAlign: 'center' }}/>
                    <Column field="id" header="ID" sortable/>
                    <Column header="AMOUNT" field="amount" dataType="numeric" editor={amountEditor} body={amountBodyTemplate} sortable style={{ minWidth: '14rem' }}/>
                
                </DataTable>
            </div>
            
        </>
    );
}
}
export default EstimateView;